<template>
  <div class="row">
    <div class="col-12">
      <div class="card mt-4">
        <div class="card-body" v-if="!onBoarding.loading">
          <!-- <LoadingSpinner v-if="onBoarding.loading" /> -->
          <Step1
            :addOrder="addOrder"
            v-if="onBoarding.step == 1 && !onBoarding.loading"
          />
          <Step2 v-if="onBoarding.step == 2 && !onBoarding.loading" />
          <Step3
            :typeForm="typeForm"
            v-if="onBoarding.step == 3"
            :addOrder="addOrder"
            :targetId="getTargetId()"
            :simplify="simplifyVersion"
          />
          <div
            class="row mt-5"
            v-if="onBoarding.step != 3 && onBoarding.substep != 0"
          >
            <div class="col-12">
              <div class="row">
                <!-- <div class="col-md-4">
                <button
                  v-if="onBoarding.substep == 1 && onBoarding.step == 1 && onBoarding.startProcess"
                  class="btn
                        btn-light
                        btn-lg btn-custom-color
                        mx-1
                        px-3
                        py-2
                         "
                  @click="getToStep(1, 0)"
                >
                  {{ $t("lang.onBoarding.back_to_start") }}
                </button>
                <button class="btn
                              cursor-pointer
                              btn-lg btn-custom-color
                              mx-1
                              px-3
                              py-2"
                        @click="getToStep(1,1)" v-else>
                  {{ $t("lang.onBoarding.go_back_campaign_creation") }}
                </button>
              </div> -->
                <div class="col-md-12 text-center" v-if="!onBoarding.loading">
                  <button
                    class="
                    btn
                    btn-sm
                    cursor-pointer
                    btn-custom-color
                    mx-1
                    px-3
                  "
                    v-if="onBoarding.showback"
                    type="button"
                    @click="back()"
                  >
                    {{ $t("lang.button.back") }}
                  </button>
                  <button
                    class="
                    btn
                    btn-sm
                    cursor-pointer
                    btn-lg btn-primary
                    mx-1
                    px-3
                    ml-5
                  "
                    v-if="onBoarding.shownext"
                    type="button"
                    :disabled="
                      (onBoarding.loading || onBoarding.disablednext) &&
                        !onBoarding.startProcess
                    "
                    @click="
                      onBoarding.startProcess ? next('startProcess') : next()
                    "
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="$t('lang.onBoarding.completeabovequestion')"
                  >
                    {{ $t("lang.button.next") }}
                    <span v-if="onBoarding.loading" class="icon-save"></span>
                  </button>
                  <small
                    class="
                    cursor-pointer
                    mx-1
                  "
                    v-if="false"
                    type="button"
                    @click="skip()"
                  >
                    {{ $t("lang.label.skip") }}
                  </small>
                </div>

                <!-- <div class="col-md-4" v-if="!onBoarding.loading && !onBoarding.startProcess">
                <button
                  class="btn
                        large
                        btn-light
                        btn-lg btn-custom-color
                        mx-1
                        px-3
                        py-2
                        float-right"
                  @click="getToStep(onBoarding.step + 1)"
                >
                  {{ $t("lang.onBoarding.skip_step") }}
                </button>
              </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="onBoarding.step == 3">
      <div class="card my-3">
        <div class="card-header" id="contractheader">
          <h5 class="mb-0">
            <button
              class="btn btn-link btn-sm"
              type="button"
              data-toggle="collapse"
              data-target="#contracts"
              aria-expanded="true"
              aria-controls="contracts"
            >
              {{ $t("lang.onBoarding.contracts_detail") }}
            </button>
          </h5>
        </div>

        <div
          v-if="!onBoarding.loading"
          id="contracts"
          class="collapse card-body my-2"
          aria-labelledby="contractheader"
        >
          <contractDetails />
        </div>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script type='text/javascript'>
  window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', 'e831e1993ab7cfdf27e793ffef9bdf0228fe64f4', { region: 'eu' });
</script>

<script>
import Step1 from "@/components/Onboarding/MultiSteps/Step1.vue";
import Step2 from "@/components/Onboarding/MultiSteps/Step2.vue";
import Step3 from "@/components/Onboarding/MultiSteps/Step3.vue";
import contractDetails from "@/components/Onboarding/ContractDetails.vue";
import { mapState, mapActions } from "vuex";
import { targetsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  data() {
    return {
      simplifyVersion: false
    };
  },

  props: {
    targetId: false,
    simplify: false,
    addOrder: false,
    typeForm: false
  },
  components: {
    Step1,
    Step2,
    Step3,
    contractDetails,
    LoadingSpinner
  },

  computed: {
    ...mapState({
      onBoarding: state => state.onboarding,
      disabledskip: state => state.onboarding.disabledskip
    })
  },
  mounted() {
    if (!this.onBoarding.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    // targetsService.getTargetPrice().then(res => {
    //   this.updatePrice(res);
    // });
  },
  created() {
    if (this.addOrder) {
      this.simplifyVersion = this.simplify;
      this.clean();
      this.setStep(1);
      this.setSubStep(1);
    }
  },
  methods: {
    ...mapActions("onboarding", {
      next: "next",
      skip: "skip",
      back: "back",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      clean: "clean",
      setLanguageId: "setLanguageId",
      updateOrderName: "updateOrderName",
      updatePrice: "updatePrice"
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getToStep(step, subStep = 1) {
      this.setStep(step);
      this.setSubStep(subStep);
    },
    getTargetId(){

      if(this.hasPermissions('adminClients') && this.onBoarding.orderId){
        this.simplifyVersion = true;
        return this.onBoarding.orderId
      }
      return this.targetId
    }
  }
};
</script>

<style scoped>
.btn-custom-color {
  background: rgba(110, 110, 110, 0.19);
}
</style>
